import { FC } from "react";
import { Form, FormControlProps } from "react-bootstrap";
import { Icon } from "../../../components";

import styles from "./formcontrolwithicon.module.scss";

interface FormControlWithIconProps extends Omit<FormControlProps, "as"> {
  icon: string;
}

const FormControlWithIcon: FC<FormControlWithIconProps> = ({
  icon,
  ...formControlProps
}) => (
  <div className={styles.formControlWithIcon}>
    <Icon name={icon} className={styles.icon} />
    <Form.Control {...formControlProps} />
  </div>
);

export default FormControlWithIcon;
